import { Component, Inject, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import { NgClass } from '@angular/common';

@Component({
    selector: 'mobilize-response-modal',
    imports: [
        MatDialogTitle,
        MatDialogContent,
        NgClass,
        MatDialogActions
    ],
    providers: [],
    templateUrl: './response-modal.component.html',
    styleUrl: './response-modal.component.scss'
})
export class ResponseModalComponent {

    private dialogRef = inject(MatDialogRef<ResponseModalComponent>);

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

    close(action?: string) {
        this.dialogRef.close(action);
    }

}
